import React from "react";

import Form from "@Components/Form";
import {
  STORAGE_CONSTANT,
  URLS,
  WORKER_GROUP_URL,

} from "configs/constants";
import { getAssignedModule } from "utils";

const initialValues = {
  // status: "",
  name: "",
  group_id: "",
  estate: "",
  active: false,
};

const WorkerGroupForm = () => {
  const formFields = [
    {
        type: "renderonly",
        key: "group_id",
        name: "group_id",
        label: "Code",
        required: true,
        disabledText: ["0000"],
      },
    {
        type: "renderonly",
        name: "name",
        key: "name",
        label: "Name",
        gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      },
      {
        type: "renderonly",
        name: "company_name",
        key: "company_name",
        label: "Company",
        gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      },
      {
        type: "renderonly",
        label: "Zone",
        key: "zone_name",
        gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },

      },
      {
        type: "renderonly",
        label: "Region",
        key: "region_name",
        gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },

      },
      {
        type: "renderonly",
        label: "Estate",
        key: "estate_name",
        gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },

      },
    {
      type: "renderonly",
      label: "Supervisor",
      name:"supervisor",
      key: "supervisor_name",
      
    },
  ];

  const formButtons = ["cancel"];


  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }
  if (actionPermission) {
    formFields.push({
      type: "renderonly",
      name: "status_label",
      label: "Active?",
      key:"status_label",
      required: true,
      nolabel: "No",
      yeslabel: "Yes",
    });
  }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={WORKER_GROUP_URL}
      listRoute={URLS.WORKER_GROUP}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Worker Group"
    />
  );
};

export default WorkerGroupForm;
